export const NETWORK_ERROR = "Network error";
